<h2 mat-dialog-title>
  View embeddings, high loading time
</h2>

<mat-dialog-content>

  @if (embeddings(); as embeddings) {

    <mat-accordion class="example-headers-align" multi>
      @for (embedding of embeddings; track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>{{ embedding.text }}
          </mat-expansion-panel-header>
          <p class="embedding">{{ embedding.embedding }}</p>
        </mat-expansion-panel>
      }
    </mat-accordion>

    @if (embeddings.length === 0) {
      <p>No embeddings found or loading</p>
    }
  } @else {
    <p>No embeddings found or loading</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions">
  <button mat-button (click)="close()">Cancel</button>
</mat-dialog-actions>
